define('scripts/lib/select-development/sss-ng-file-upload-fixes',["ng"], function () {
	"use strict";
	var sssNgFileUploadFixes = angular.module("sssNgFileUploadFixes", []);

	sssNgFileUploadFixes.directive("ngfMultiple", ["$compile", function ($compile) {
		var priority = -10,
			addAttr = "ngfKeep",
			definition = {
				priority: priority,
				link: function (scope, iElement, iAttrs) {
					if (!Object.hasOwnProperty.call(iAttrs, addAttr)) {
						iAttrs.$observe(definition.name, function (newValue) {
							iAttrs.$set(addAttr, newValue);
						});
					}
				}
			};
		return definition;
	}]);
});
